export default "__VITE_ASSET__BnzkangS__";